///<reference path="../modal/modal.interface.ts"/>
///<reference path="../modal/modal.enums.ts"/>
module Meevo.Components.BaseClasses {

    export abstract class KioskBase {

        logOutModalHeader: string;
        skipReLogin: boolean;
        logout?: boolean;
        private closePopupOpen: boolean;

        constructor(protected modalService: Meevo.Components.Modal.IModalService,
                    protected $rootScope: ng.IRootScopeService,
                    protected $scope: ng.IScope,
                    protected kioskModelLogic: Meevo.Components.Common.KioskModeLogic,
                    protected delayLogOut: boolean = false) {
            this.closePopupOpen = false;

            if (!this.skipReLogin && !this.delayLogOut) {
                this.doLogOut();
            }

            $scope.$on(Meevo.Components.Common.Messages.CLOSE_KIOSK_MODE_OUTSIDE, () => {
                 this.showClosePopup();
            });
        }

        protected doLogOut() {
            if(this.logout) {
                this.kioskModelLogic.enableLogOutOnReload(this.$rootScope);
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.ENABLE_LOGOUT_AFTER_RELOAD);
        }

        abstract close(response?: any): void;

        showClosePopup() {
            if (this.skipReLogin) {
                this.close();

                return;
            }

            if(this.closePopupOpen) {
                return;
            }

            this.closePopupOpen = true;
            const options = {
                templateUrl: 'app/components/kioskModeExitModal/kiosk-mode-exit-modal.template.html',
                controller: 'meevo.components.kioskModeExitModal.KioskModeExitModalController',
                controllerAs: 'vm',
                bindToController: true,

                locals: {
                    oneTry: false,
                    headerText: this.logOutModalHeader || 'LABEL_EXIT_FORM',
                }
            };

            this.modalService.showCustom(options, 0, true)
                .then((response: any) => {
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_DAF_FORM);
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_KIOSK_MODE);

                        this.close(response);
                        this.closePopupOpen = false;
                    }
                )
                .catch((res: any) => {
                    this.closePopupOpen = false;
                });
        }
    }
}
